import { render, staticRenderFns } from "./CustomTags.vue?vue&type=template&id=ecc6ce6c&scoped=true"
import script from "./CustomTags.vue?vue&type=script&lang=js"
export * from "./CustomTags.vue?vue&type=script&lang=js"
import style0 from "./CustomTags.vue?vue&type=style&index=0&id=ecc6ce6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc6ce6c",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QIcon});
